__turbopack_context__.v({
  "methodDescription": "BsrxTq_methodDescription",
  "methodImage": "BsrxTq_methodImage",
  "methodImageWrapper": "BsrxTq_methodImageWrapper",
  "methodSection": "BsrxTq_methodSection",
  "methodTextContent": "BsrxTq_methodTextContent",
  "methodsWrapper": "BsrxTq_methodsWrapper",
  "pageTitle": "BsrxTq_pageTitle",
});
